var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#212322;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.8,248.89c-0.19,35.35-10.64,68.7-31.46,98.3c-4.57,6.5-9.51,12.39-16.01,19.09 c-5.29,5.46-13.46,12.8-17.74,16.11c-13.56,10.46-30.08,19.52-44.3,24.72c-68.29,24.98-143.77,4.45-190.27-51.39 c-20.82-25-34.99-60.06-37.44-92.64c-2.73-36.24,5.23-70.68,23.66-101.32c17.64-29.32,43.3-52.14,75.25-66.94 c30.63-14.19,69.3-18.43,102.58-11.58c34.71,7.15,64.68,23.73,88.91,48.96c23.9,24.88,39.33,56.02,45.03,91.31 C410.1,230.2,410.75,240.12,410.8,248.89c0.12,22.42,34.97,22.47,34.85,0c-0.46-85.29-54.34-161.83-134.19-191.48 c-78.92-29.31-172.17-4.19-225.69,60.75c-54.73,66.41-63.19,162.29-18.13,236.29c44.48,73.05,131.07,110.42,214.77,94.11 c81.48-15.89,148.09-84.76,160.51-166.96c1.64-10.86,2.66-21.71,2.72-32.7C445.77,226.46,410.92,226.44,410.8,248.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOff);
export default __webpack_public_path__ + "static/media/radio_off.0dfb1ed8c4d3a8e98f543df13681f686.svg";
export { ForwardRef as ReactComponent };